export default "/images/andreani.svg?a634b6bee4b8a96f854341360b0e866f";